import { DataService } from 'app/services/data.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormatService, HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-sidebar-upcoming-follow-up',
  templateUrl: './sidebar-upcoming-follow-up.component.html',
  styleUrls: ['./sidebar-upcoming-follow-up.component.scss'],
})
export class SidebarUpcomingFollowUpComponent implements OnInit {
  @Input('customer')
  set customer(customer: any) {
    this._customer = customer;

    if (customer && customer._id) {
      this.httpService.getScheduledFollowUp(customer._id).then(
        (campaign) => {
          const { upcomingFollowUps = [], pastFollowUps = [] } = this.formatService.formatScheduledFollowUp(campaign, customer);

          this.upcomingFollowUps = upcomingFollowUps;
          this.pastFollowUps = pastFollowUps;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  upcomingFollowUps: any[] = [];
  pastFollowUps: any[] = [];
  _customer: any = {};

  constructor(private dataService: DataService, private httpService: HTTPService, private helperService: HelperService, private formatService: FormatService) {}

  ngOnInit() {}

  handleFollowUpPanel(viewType: string) {
    this.dataService.sendData(
      this.dataService.typeFollowUp('RO', {
        viewType,
        event: '',
        customer: this._customer,
        customerId: this._customer._id,
      })
    );
  }
}
